export function TickmillAppIcon() {
  return (
    <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect opacity='0.9' width='48' height='48' rx='11.25' fill='url(#paint0_linear_6154_67486)' />
      <mask
        id='mask0_6154_67486'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='48'
        height='48'
      >
        <path
          d='M31.2652 0H16.7348C11.916 0 9.5068 0 6.9132 0.819995C4.0812 1.85081 1.8508 4.0812 0.820001 6.9132C0 9.5068 0 11.9164 0 16.7348V31.2652C0 36.084 0 38.4928 0.820001 41.0868C1.8508 43.9188 4.0812 46.1492 6.9132 47.1796C9.5068 48 11.916 48 16.7348 48H31.2652C36.084 48 38.4928 48 41.0868 47.1796C43.9188 46.1492 46.1492 43.9188 47.18 41.0868C48 38.4928 48 36.084 48 31.2652V16.7348C48 11.9164 48 9.5068 47.18 6.9132C46.1492 4.0812 43.9188 1.85081 41.0868 0.819995C38.4928 0 36.084 0 31.2652 0Z'
          fill='#C4C4C4'
        />
      </mask>
      <g mask='url(#mask0_6154_67486)'>
        <rect width='48' height='48' fill='#490619' />
        <path
          d='M26.3851 31.7194H20.7797C20.1039 31.7194 19.4679 31.3616 19.1299 30.7653L15.9099 25.1799C15.572 24.5836 15.572 23.868 15.9099 23.2717L19.1299 17.6863C19.4679 17.0899 20.1039 16.7322 20.7797 16.7322H26.3851L30.8375 9C30.7381 9 30.6387 9 30.5592 9H17.4404C16.049 9 14.7769 9.73545 14.0812 10.9479L7.52177 22.2778C6.82608 23.4705 6.82608 24.9612 7.52177 26.1539L14.0812 37.5235C14.7769 38.7161 16.049 39.4715 17.4404 39.4715H30.5592C30.6586 39.4715 30.758 39.4715 30.8574 39.4715L26.4049 31.7393L26.3851 31.7194Z'
          fill='#FF0044'
        />
        <path
          d='M40.4781 22.2786L33.9187 10.9089C33.879 10.8294 33.8193 10.7499 33.7597 10.6704L29.3073 18.4026L32.1099 23.2724C32.4478 23.8687 32.4478 24.5843 32.1099 25.1806L29.3073 30.0505L33.7597 37.7827C33.8193 37.7031 33.879 37.6236 33.9187 37.5441L40.4781 26.1745C41.1738 24.9819 41.1738 23.4911 40.4781 22.2985V22.2786Z'
          fill='#28F981'
        />
      </g>
    </svg>
  )
}
